import React from "react";

type StoryProps = {
  img: string;
  username: string;
  fullname: string;
  userImage?: string;
  /** Optional: call when ring is clicked (for stable callback from parent). */
  onClick?: () => void;
  /** Optional: stable callback + index so parent can pass useCallback without new closures per item. */
  onSelectUserIndex?: (index: number) => void;
  userIndex?: number;
  /** When true, show gray border (story has been seen) instead of gradient */
  seen?: boolean;
};

const Story: React.FC<StoryProps> = ({ img, username, fullname, userImage, onClick, onSelectUserIndex, userIndex, seen }) => {
  const profileImage = userImage || img || '/default-avatar.svg';
  const handleClick = () => {
    if (onSelectUserIndex != null && userIndex != null) {
      onSelectUserIndex(userIndex);
    } else {
      onClick?.();
    }
  };

  const ringClass = seen
    ? "bg-gray-400 dark:bg-gray-500"
    : "bg-gradient-to-tr from-[#f58529] via-[#dd2a7b] to-[#515bd4]";

  return (
    <div className="flex flex-col items-center space-y-2 flex-shrink-0 relative">
      <div
        className={`${ringClass} rounded-full p-[3px] cursor-pointer hover:scale-105 transition-transform duration-200 ease-out`}
        onClick={handleClick}
      >
        <div className="bg-white dark:bg-gray-800 rounded-full p-[3px]">
          <img
            className="h-14 w-14 rounded-full object-cover"
            src={profileImage}
            alt={`${username}'s profile`}
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = '/default-avatar.svg';
            }}
          />
        </div>
      </div>
      
      <p className="text-xs w-14 truncate text-center text-gray-900 dark:text-gray-100 leading-tight">{fullname}</p>
    </div>
  );
};

export default React.memo(Story);
